import { IntlShape } from "react-intl";

const getStepNames = (intl: IntlShape): string[] => [
  intl.formatMessage({
    id: "imports.uploadStep.title",
    defaultMessage: "Upload",
    description: "Title of first step of import adding",
  }),
  intl.formatMessage({
    id: "imports.matchFieldsStep.title",
    defaultMessage: "Match fields",
    description: "Title of second step of import adding",
  }),
  intl.formatMessage({
    id: "imports.finalizeStep.title",
    defaultMessage: "Finalize",
    description: "Title of third step of import adding",
  }),
];

export default getStepNames;
